import { useState, ChangeEvent } from "react";
import { toast } from "react-toastify";

import Spinner from "@/components/Spinner/Spinner";
import { Button } from "@/components/UiElements";
import updateTheme from "@/services/ThemeService/updateTheme";
import addTheme from "@/services/ThemeService/addTheme";
import { Theme } from "@/types/theme";

type AlertProps = {
    title?: string;
    message?: string;
    onUpdateSuccess?: (updatedTheme: Theme) => void;
    cancel?: string;
    button?: string;
    handleOk?: () => void;
    handleCancel?: () => void;
};

const Alert = ({
                   title,
                   message,
                   cancel,
                   button,
                   handleCancel,
                   handleOk,
               }: AlertProps) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="modal-content bg-white p-4 rounded-md w-6/12">
                <div className="flex flex-col justify-center p-5">
                    <h2 className="text-base font-extrabold leading-6 text-gray-900">{title}</h2>
                    <div className="flex justify-start w-full my-3">
                        <div className="text-text-md px-4 overflow-y-auto">{message}</div>
                    </div>
                    <div className="flex items-center justify-end gap-sm">
                        {cancel && (
                            <Button type="alt" onClick={handleCancel}>
                                {cancel}
                            </Button>
                        )}
                        <Button type="primary" onClick={handleOk}>
                            {button}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alert;
